import { render } from "./CommentComp.vue?vue&type=template&id=4ec626a4&scoped=true"
import script from "./CommentComp.vue?vue&type=script&lang=js"
export * from "./CommentComp.vue?vue&type=script&lang=js"

import "./comment-comp-responsive.css?vue&type=style&index=0&id=4ec626a4&scoped=true&lang=css&external"
import "./CommentComp.vue?vue&type=style&index=1&id=4ec626a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec626a4"]])

export default __exports__